
import { defineComponent, reactive, toRefs } from 'vue';
function user1() {
    const user = reactive({
        name1: 'abc',
        age2: 20,
    });
    return {
        ...toRefs(user),
    }
}
export default defineComponent({
    name: 'App',
    setup() {
        const user = reactive({
            name: 'abc',
            age: 20,
        });
        const {name,age} = toRefs(user);
        const update = () =>{
            name.value += "==";
            age.value += 1;
        }
        return {
            // ...toRefs(user),
            name,
            age,
            ...user1(),
            update,
        }
    }
});
